import { useState, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  // Use a ref to store the debounced function
  // This ensures the same debounced function instance is used across renders
  const debouncedSetState = useRef(
    debounce((newValue: T) => {
      setDebouncedValue(newValue);
    }, delay)
  ).current; // .current gets the latest ref value

  useEffect(() => {
    // Call the debounced function when the value changes
    debouncedSetState(value);

    // Cleanup function to cancel the debounce on unmount or if value/delay changes
    return () => {
      debouncedSetState.cancel();
    };
  }, [value, delay, debouncedSetState]);

  return debouncedValue;
} 